import { toDate } from 'date-fns';
import moment from 'moment';

export default (timestamp, dateFormat = 'DD/MM/YYYY') => {
  const date = toDate(Number(timestamp * 1000));

  return moment(date, dateFormat);
};
